import { defineMessages } from 'react-intl';

export default defineMessages({
    EndorsementPageHeader: {
        id: 'cep.components.sgEndorsementDriverPage.Header',
        defaultMessage: 'Driver changes'
    },
    WhatChange: {
        id: 'cep.components.sgEndorsementDriverPage.WhatChange',
        defaultMessage: 'What change do you want to make?'
    },
    AddDriver: {
        id: 'cep.components.sgEndorsementDriverPage.AddDriver',
        defaultMessage: 'Add driver'
    },
    RemoveDriver: {
        id: 'cep.components.sgEndorsementDriverPage.RemoveDriver',
        defaultMessage: 'Remove driver'
    },
    GoBackLabel: {
        id: 'cep.components.sgEndorsementDriverPage.GoBackLabel',
        defaultMessage: 'Back'
    },
    BackToMyAccount: {
        id: 'cep.components.sgEndorsementDriverPage.BackToMyAccount',
        defaultMessage: 'Back to My Account'
    }
});
